"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.ChipProps = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _core = require("@material-ui/core");

var _excluded = ["dataQa", "label", "onClick", "color", "variant", "additionalClasses"];

var styles = function styles() {
  return {
    chip: {
      marginLeft: 8,
      marginTop: 8
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/** A compact component for representing an input, attribute, or action */

var Chip = function Chip(_ref) {
  var dataQa = _ref.dataQa,
      label = _ref.label,
      onClick = _ref.onClick,
      color = _ref.color,
      variant = _ref.variant,
      additionalClasses = _ref.additionalClasses,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("span", {
    "data-qa": dataQa
  }, /*#__PURE__*/_react["default"].createElement(_core.Chip, (0, _extends2["default"])({
    label: label,
    variant: variant,
    onClick: onClick,
    className: (0, _classnames["default"])(classes.chip, additionalClasses),
    color: color
  }, props)));
};

var ChipProps = {
  /** The content of the chip */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,

  /** Styling applied to the button. */
  variant: _propTypes["default"].oneOf(['default', 'outlined']),

  /** The color of the component */
  color: _propTypes["default"].string.isRequired,

  /** Additional classes for styling passed down to the component */
  additionalClasses: _propTypes["default"].object,

  /** The size of the chip. */
  size: _propTypes["default"].oneOf(['small', 'medium']),

  /**
   * Callback fired when the component is clicked.
   *
   * **Signature:**
   * ```
   * function(event: object) => void
   * ```
   * *event*: The event source of the callback.
   */
  onClick: _propTypes["default"].func
};
exports.ChipProps = ChipProps;
Chip.propTypes = ChipProps;
Chip.defaultProps = {
  color: 'default',
  variant: 'default'
};
var _default = Chip;
exports["default"] = _default;